import { addSeconds, addWeeks, differenceInMinutes, differenceInDays, differenceInYears, endOfMonth, endOfDay, format, formatDistance, getDaysInMonth, getWeekOfMonth, getHours, getMinutes, getDay, getWeek, getWeekYear, getMonth, getQuarter, getYear, setYear, setWeek, setWeekYear, setMonth, setQuarter, isSameDay, isSameMonth, isSameYear, parse, startOfMonth, startOfWeek, startOfISOWeek, startOfDay, startOfYear, startOfWeekYear, startOfQuarter, endOfWeek, endOfYear, subDays } from 'date-fns';

// Import default locale or specific ones if consistently needed for these functions
// For simplicity, we'll rely on date-fns defaults here, but this can be enhanced
// if specific locale objects need to be passed to these functions like in your
// existing custom format function.

var dateFnsHelpers = {
  addSeconds: addSeconds,
  addWeeks: addWeeks,
  differenceInMinutes: differenceInMinutes,
  differenceInDays: differenceInDays,
  differenceInYears: differenceInYears,
  endOfMonth: endOfMonth,
  endOfDay: endOfDay,
  format: format,
  formatDistance: formatDistance,
  getDaysInMonth: getDaysInMonth,
  getWeekOfMonth: getWeekOfMonth,
  getHours: getHours,
  getMinutes: getMinutes,
  getDay: getDay,
  getWeek: getWeek,
  getWeekYear: getWeekYear,
  getMonth: getMonth,
  getQuarter: getQuarter,
  getYear: getYear,
  setYear: setYear,
  setWeek: setWeek,
  setWeekYear: setWeekYear,
  setMonth: setMonth,
  setQuarter: setQuarter,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth,
  isSameYear: isSameYear,
  parse: parse,
  startOfMonth: startOfMonth,
  startOfWeek: startOfWeek,
  startOfISOWeek: startOfISOWeek,
  startOfDay: startOfDay,
  startOfYear: startOfYear,
  startOfWeekYear: startOfWeekYear,
  startOfQuarter: startOfQuarter,
  endOfWeek: endOfWeek,
  endOfYear: endOfYear,
  subDays: subDays
};
export default (function (context, inject) {
  // Injects as $dateFns
  // Accessible as this.$dateFns in Options API (though Nuxt Bridge leans to Composition)
  // or via useNuxtApp().$dateFns in Composition API
  inject('dateFns', dateFnsHelpers);
});